import React from 'react';
import { Line } from 'react-chartjs-2';
import { Card, CardBody, CardHeader } from 'reactstrap';

const TimeSeriesChart = ({ timeSeries }) => {
  if (!timeSeries || timeSeries.length === 0) return null;

  const data = {
    labels: timeSeries.map((t) => t.month),
    datasets: [
      {
        label: 'Ventas Completadas',
        data: timeSeries.map((t) => t.completed),
        borderColor: '#537bc4',
        backgroundColor: 'rgba(83, 123, 196, 0.1)',
        fill: true,
        yAxisID: 'y-left',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          id: 'y-left',
          position: 'left',
          ticks: { beginAtZero: true, precision: 0 },
          scaleLabel: { display: true, labelString: 'Cantidad' },
        },
      ],
    },
  };

  return (
    <Card className="mb-4">
      <CardHeader>Ventas por Mes</CardHeader>
      <CardBody style={{ height: '300px' }}>
        <Line data={data} options={options} />
      </CardBody>
    </Card>
  );
};

export default TimeSeriesChart;
